/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountMaximumSignupPageBundleQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountMaximumSignupPageBundleQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly maximumSignupPageBundle: number | null } | null };


export const AccountMaximumSignupPageBundleDocument = gql`
    query AccountMaximumSignupPageBundle($accountId: AccountId!) {
  account(id: $accountId) {
    id
    maximumSignupPageBundle
  }
}
    `;

/**
 * __useAccountMaximumSignupPageBundleQuery__
 *
 * To run a query within a React component, call `useAccountMaximumSignupPageBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMaximumSignupPageBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMaximumSignupPageBundleQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountMaximumSignupPageBundleQuery(baseOptions: Apollo.QueryHookOptions<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables> & ({ variables: AccountMaximumSignupPageBundleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>(AccountMaximumSignupPageBundleDocument, options);
      }
export function useAccountMaximumSignupPageBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>(AccountMaximumSignupPageBundleDocument, options);
        }
export function useAccountMaximumSignupPageBundleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>(AccountMaximumSignupPageBundleDocument, options);
        }
export type AccountMaximumSignupPageBundleQueryHookResult = ReturnType<typeof useAccountMaximumSignupPageBundleQuery>;
export type AccountMaximumSignupPageBundleLazyQueryHookResult = ReturnType<typeof useAccountMaximumSignupPageBundleLazyQuery>;
export type AccountMaximumSignupPageBundleSuspenseQueryHookResult = ReturnType<typeof useAccountMaximumSignupPageBundleSuspenseQuery>;
export type AccountMaximumSignupPageBundleQueryResult = Apollo.QueryResult<AccountMaximumSignupPageBundleQuery, AccountMaximumSignupPageBundleQueryVariables>;